<template>
    <div>
        <div layout="column" layout-align="start start" class="full-width pr2-pc pl2-pc mb20-pc pb1-pc mb2-mobile pr1-mobile pl1-mobile bg-white">
            <div layout="row" layout-align="start center" class="title grey--text text-uppercase font-weight-medium mb2-pc mb1-mobile mt3-pc">{{$t('nav.book')}}
                <v-btn @click="displayFilters = !displayFilters" icon class="hidden-md-and-up ml-1"><i :class="['mdi', displayFilters ? 'mdi-filter-remove' : 'mdi-filter']" style="color: black"></i></v-btn>
            </div>
            <div v-if="!$vuetify.breakpoint. smAndDown || displayFilters" layout="row" layout-wrap layout-align="start center" class="full-width">
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.levels')"
                        :hint="$t('filters.levels_select')"
                        persistent-hint multiple
                        solo v-model="filters.level"
                        :items="levels"
                        @change="fetch(true)"
                        class="mr5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.sectors')"
                        :hint="$t('filters.sectors_select')"
                        persistent-hint multiple
                        solo v-model="filters.sector"
                        :items="sectors"
                        @change="fetch(true)"
                        class="mr5-pc ml5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.rds')"
                        :hint="$t('filters.rds_select')"
                        persistent-hint multiple
                        solo v-model="filters.regional_directorate_id"
                        :items="rds" item-value="id" :item-text="itemLabel"
                        @change="fetch(true)"
                        autocomplete
                        class="ml5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.regions')"
                        :hint="$t('filters.regions_select')"
                        persistent-hint multiple
                        solo v-model="filters.region_id"
                        :items="regions" item-value="id" :item-text="itemName"
                        @change="fetch(true)"
                        autocomplete
                        class="mr5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('params.cities')"
                        :hint="$t('filters.cities_select')"
                        persistent-hint multiple
                        solo v-model="filters.city_id"
                        :items="$store.state.cities" item-value="id" item-text="label"
                        @change="fetch(true)"
                        autocomplete
                        class="mr5-pc ml5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('schools.title')"
                        :hint="$t('filters.schools_select')"
                        persistent-hint multiple
                        solo v-model="filters.school_id"
                        :items="schools" item-value="id" item-text="name"
                        @change="fetch(true)"
                        autocomplete
                        class="ml5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <div layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-text-field solo :label="$t('filters.keywords')" :hint="$t('filters.schools_hint')" persistent-hint v-model="filters.keywords" @keyup.enter="fetch(true)" class="mr5-pc width-100-mobile"></v-text-field>
                </div>
                <div v-if="isAdmin" layout="column" :flex="$vuetify.breakpoint. smAndDown ? 100 : 33">
                    <v-select
                        :label="$t('filters.status')"
                        :hint="$t('filters.status_hint')"
                        persistent-hint
                        solo v-model="filters.is_enabled"
                        :items="status"
                        @change="fetch(true)"
                        class="mr5-pc ml5-pc width-100-mobile"
                    >
                    </v-select>
                </div>
                <span flex></span>
                <v-btn depressed color="secondary" @click="fetch(true)" large>{{$t('filters.filter_btn')}}</v-btn>
                {{$t('_.or')}}
                <a href="#" class="ml-2 black--text" @click.prevent="resetFilters">{{$t('filters.reinit')}}</a>
            </div>
        </div>
        <div layout="column" layout-align="start start" class="full-width pl2-pc pr2-pc pt3-pc pb5-pc px1-mobile py1-mobile bg-white">
            <div layout="row" layout-align="start center" layout-wrap class="full-width">
                <div class="font-weight-bold subheading">
                    <span class="secondary--text">{{total}}</span>&nbsp;
                    <span v-if="total > 1">
                        <span class="text-lowercase">{{$t('representatives.representatives')}}</span>
                        {{$t('filters.match_pl')}} {{$t('filters.criteria')}}
                    </span>
                    <span v-else>
                        <span class="text-lowercase">{{$t('representatives.representative')}}</span>
                        {{$t('filters.match')}} {{$t('filters.criteria')}}
                    </span>
                </div>
                <span class="hidden-sm-and-down" flex></span>
                {{$t('representatives.sort')}}&nbsp;
                <a @click.prevent="filters.sortBy = 'firstname'; fetch(true)" href="#" :class="{'black--text' : (filters.sortBy != 'firstname')}">{{$t('representatives.name')}}</a>
                <span class="mx-2">/</span>
                <a @click.prevent="filters.sortBy = 's.name'; fetch(true)" href="#" :class="{'black--text' : (filters.sortBy != 's.name')}">{{$t('representatives.school')}}</a>
                <span class="mx-2">/</span>
                <a @click.prevent="filters.sortBy = 'sector'; fetch(true)" href="#" :class="{'black--text' : (filters.sortBy != 'sector')}">{{$t('representatives.sector')}}</a>
            </div>

            <div v-if="isAdmin" class="mt-1">
                <v-btn @click="newRepresentative" class="ml-0" flat outline color="secondary">
                    <span style="text-transform: none">{{$t('representatives.add_btn')}}</span>
                </v-btn>
            </div>
            <div layout="row" layout-align="start center" layout-wrap class="full-width mt-3">
                <v-card v-for="r in representatives" layout="row" layout-align="start center" class="school-card pr1-pc mt3-pc" flat :to="``" :flex="$vuetify.breakpoint. smAndDown ? 100 : 50" :key="'rep_'+r.id">

                    <div class="ml3-pc mt3-pc mb3-pc mr2-pc ma1-mobile pa2-pc pa1-mobile">
                        <avatar @click.native="$router.push({name: 'representatives-show', params: {id: r.id}})" size="50" :image="getImageData(r.id)" :fullname="r.firstname + ' ' + r.lastname" class="clickable"></avatar>
                    </div>

                    <div layout="column" flex>
                        <div @click="$router.push({name: 'representatives-show', params: {id: r.id}})" class="subheading clickable pl-1">
                            {{r.firstname}}
                            <span class="font-weight-bold">
                                {{ r.lastname }}
                            </span>
                            <v-icon v-if="isAdmin && (r.sector == primary) && !r.cycle_id" color="warning" :title="$t('representatives.cycle_miss')">mdi-alert</v-icon>
                            <v-icon v-else-if="isAdmin && (r.sector == secondary) && !r.regime_id" color="warning" :title="$t('representatives.regime_miss')">mdi-alert</v-icon>
                        </div>
                        <div class="caption pl-1">
                            {{r.school.name}}
                        </div>
                        <div layout="row" layout-wrap layout-align="start center">
                        <v-chip label :color="levelColor(r.level)" class="text-lowercase" text-color="white" style="width: fit-content" small>
                            {{levelLabel(r.level)}}
                        </v-chip>
                        </div>
                    </div>
                    <div v-if="isAdmin" layout="column">
                        <div :layout="$vuetify.breakpoint. smAndDown ? 'column' : 'row'" layout-align="center center">
                            <v-btn @click="editRepresentative(r)" :title="$t('_.edit')" class="mx-0 ma0-mobile" icon ><v-icon color="secondary">mdi-pencil</v-icon></v-btn>
                            <v-btn :title="r.is_enabled ? $t('_.disable') : $t('_.enable')" class="mx-0 ma0-mobile" icon @click="toggle(r)">
                                <v-icon color="secondary">{{ r.is_enabled ? 'mdi-lock-outline': 'mdi-lock-open-outline' }}</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-card>
            </div>
            <div class="text-xs-center mt-5 full-width">
                <v-pagination
                v-model="filters.page"
                :length="pages" color="secondary"
                total-visible="5"
                @input="fetch(false)"
                ></v-pagination>
            </div>
        </div>
        <representative-form :visible.sync="representativeDialog" @created="fetch" @updated="fetch" @avatarDeleted="fetch" :value="editingRepresentative"></representative-form>
    </div>
</template>

<script>
    import Params from '@/api/params'
    import Representatives from '@/api/representatives'
    import Schools from '@/api/schools'
    import I18nMixin from '@/mixins/i18n'
    import Consts from '@/consts'
    import ImageMixin from '@/mixins/image'
    import Avatar from '@/components/shared/Avatar.vue'
    import RepresentativeForm from '@/components/shared/RepresentativeForm.vue'
    import Auth from '@/plugins/auth'

    export default {
        mixins: [I18nMixin, ImageMixin],
        components: {Avatar, RepresentativeForm},
        data () {
          return {
                storeKey: 'representatives',
                filters: {
                    keywords: null,
                    is_enabled: null,
                    sector: [],
                    city_id: [],
                    regional_directorate_id: [],
                    region_id: [],
                    rowsPerPage: 8,
                    descending: 0,
                    sortBy: 'firstname',
                    page: 1,
                },
                representatives: [],
                regions: [],
                rds: [],
                schools: [],
                displayFilters: false,
                total: 0,
                imgs: {},
                imgsLoad: {},
                representativeDialog: false,
				editingRepresentative: {
                    lang_id: 'fr',
                    langs_ids: [],
                    sector: null,
                    birthday: null,
                    mandate_start: null,
                    mandate_end: null
                }
            }
        },
        mounted() {
            const storedFilters = this.$store.getters.getFilters(this.storeKey)
            if (storedFilters) {
              this.filters = storedFilters
            }

            this.fetch();
            this.fetchParams();
        },
        watch: {
            representativeDialog(val){
                if(!val){
                    this.editingRepresentative = {
                        lang_id: 'fr',
                        langs_ids: [],
                        sector: null,
                        birthday: null,
                        mandate_start: null,
                        mandate_end: null
                    };
                }
            }
        },
        methods: {
            fetch (reset = false) {
                if(reset){
                    this.filters.page = 1;
                }
                Representatives.getList(this.filters).then(res => {
                    this.representatives = res.data.items;
                    this.total = res.data.total;
                    this.$store.commit('SET_FILTERS', {key: this.storeKey, data: this.filters})

                    this.imgs = {};
                    this.imgsLoad = {};

                    for(let i = 0; i< this.representatives.length; i++){
                        if(this.representatives[i].avatar_id){
                            this.getImage('/assets/users/' + this.representatives[i].id, this.representatives[i].id);
                        }
                    }
                })
            },
            fetchParams () {
                Schools.getList({sortBy: 'name', is_enabled: 1}).then(res => {
                    this.schools = res.data;
                })
                Params.getList('regional-directorates', {is_enabled: 1}).then(res => {
                    this.rds = res.data;
                    this.rds = this.rds.sort((a,b) => (this.i18n(a.label) > this.i18n(b.label)) ? 1 : ((this.i18n(b.label) > this.i18n(a.label)) ? -1 : 0));
                })
                Params.getList('regions', {is_enabled: 1}).then(res => {
                    this.regions = res.data;
                    this.regions = this.regions.sort((a,b) => (this.i18n(a.name) > this.i18n(b.name)) ? 1 : ((this.i18n(b.name) > this.i18n(a.name)) ? -1 : 0));
                })
            },
            resetFilters () {
                this.filters = {
                    keywords: null,
                    is_enabled: null,
                    sector: [],
                    city_id: [],
                    regional_directorate_id: [],
                    region_id: [],
                    rowsPerPage: 8,
                    descending: 0,
                    sortBy: 'firstname',
                    page: 1
                };
                this.fetch();
            },
            toggle (item) {
                if (item.is_enabled) {
                    Representatives.disable(item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('representatives.disable'))
                    })
                } else {
                    Representatives.enable(item.id).then(() => {
                        this.fetch();
                        this.$snotify.success(this.$t('representatives.enable'))
                    })
                }
            },
            newRepresentative () {
                this.representativeDialog = true;
            },
            editRepresentative (r) {
                this.editingRepresentative = Object.assign({}, r);
                if(this.editingRepresentative.langs_ids === undefined){
                    this.editingRepresentative.langs_ids = [];

                    for(let i = 0; i < this.editingRepresentative.langs.length; i++){
                        this.editingRepresentative.langs_ids.push(this.editingRepresentative.langs[i].id);
                    }
                }
                this.representativeDialog = true;
            },
            itemName(item){
                return this.i18n(item.name);
            },
            itemLabel(item){
                return this.i18n(item.label);
            },
            levelLabel(l){
                switch (l) {
                    case Consts.MINISTRY:
                        return this.$t('users.lv_min');
                    case Consts.NATIONAL:
                        return this.$t('users.lv_nat');
                    case Consts.SECTORAL:
                        return this.$t('users.lv_sec');
                    case Consts.LOCAL:
                        return this.$t('users.lv_loc');
                }
            },
            levelColor(l){
                switch (l) {
                    case Consts.MINISTRY:
                        return 'primary';
                    case Consts.NATIONAL:
                        return 'pink';
                    case Consts.SECTORAL:
                        return 'secondary';
                    case Consts.LOCAL:
                        return 'brown';
                }
            },
        },
        computed: {
            sectors () {
                return [
                    { value: Consts.PRIMARY, text: this.$t('schools.sector_prim') },
                    { value: Consts.SECONDARY, text: this.$t('schools.sector_sec') },
                    { value: Consts.COMPETENCECENTRE, text: this.$t('schools.sector_comp') },
                ]
            },
            status () {
                return [
                    { value: null, text: this.$t('filters.status_all') },
                    { value: 1, text: this.$t('filters.status_active') },
                    { value: 0, text: this.$t('filters.status_inactive') },
                ]
            },
            primary(){
                return Consts.PRIMARY;
            },
            secondary(){
                return Consts.SECONDARY;
            },
            levels () {
                return [
                    { value: Consts.NATIONAL, text: this.$t('users.lv_nat') },
                    { value: Consts.SECTORAL, text: this.$t('users.lv_sec') },
                    { value: Consts.LOCAL, text: this.$t('users.lv_loc') },
                ]
            },
            pages () {
                return Math.ceil(this.total / this.filters.rowsPerPage);
            },
            isAdmin () {
                return Auth.user.is_admin;
            }
        }
    }
</script>
<style scoped>
</style>
